import { CardSingleIcon, CardMultipleIcon, EyeOpenIcon, EyeClosedIcon } from '@/icons'
import { useFilterStore } from '@/store/filterStore'

const toggleStyles =
  'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap'
const collapseActiveStyles = 'bg-blue-600 text-white hover:bg-blue-700'
const hiddenActiveStyles = 'bg-yellow-600 text-white hover:bg-yellow-700'
const inactiveToggleStyles = 'text-secondary hover:bg-hover hover:text-primary'

export function CollapseVariantsToggle() {
  const { collapseVariants, toggleCollapseVariants } = useFilterStore()

  return (
    <button
      onClick={toggleCollapseVariants}
      aria-pressed={collapseVariants}
      aria-label={
        collapseVariants
          ? 'Variant display: Player mode (collapsed). Click to switch to Collector mode.'
          : 'Variant display: Collector mode (separate). Click to switch to Player mode.'
      }
      className={`${toggleStyles} ${collapseVariants ? collapseActiveStyles : inactiveToggleStyles}`}
      title={
        collapseVariants
          ? 'Player mode: variants collapsed into single entries'
          : 'Collector mode: tracking all card variants separately'
      }
    >
      {collapseVariants ? <CardMultipleIcon className="w-4 h-4" /> : <CardSingleIcon className="w-4 h-4" />}
      {collapseVariants ? 'Player' : 'Collector'}
    </button>
  )
}

export function ShowHiddenToggle() {
  const { showHidden, toggleShowHidden } = useFilterStore()

  return (
    <button
      onClick={toggleShowHidden}
      aria-pressed={showHidden}
      aria-label={
        showHidden
          ? 'Hidden cards: showing all. Click to filter hidden cards out.'
          : 'Hidden cards: filtered out. Click to show hidden cards.'
      }
      className={`${toggleStyles} ${showHidden ? hiddenActiveStyles : inactiveToggleStyles}`}
      title={showHidden ? 'Showing hidden cards' : 'Hidden cards are filtered out'}
    >
      {showHidden ? <EyeOpenIcon className="w-4 h-4" /> : <EyeClosedIcon className="w-4 h-4" />}
      {showHidden ? 'Showing All' : 'Filtered'}
    </button>
  )
}
